<template>
  <b-row class="align-items-end">
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <SearchTextInput
        v-model="searchUserTeamValue"
        label="UserTeam"
        placeholder="Code or Name"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <SearchTextInput
        v-model="searchUserGroupValue"
        label="UserGroup"
        placeholder="Code or Name"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <StatusDropdown
        :status-filter.sync="statusFilterValue"
        @change-status-filter="fetchFilter()"
      />
    </b-col>
    <b-col
      sm="12"
      md="3"
      class="mb-1 mb-sm-0">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="w-100"
        variant="primary"
        @click="fetchFilter()">
        <feather-icon
          icon="SearchIcon"
          class="mr-50 mr-md-0 mr-lg-0 mr-xl-50" />
        <span class="align-middle">Search</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import SearchTextInput from '@/components/Filter/SearchTextInput.vue'
import StatusDropdown from '@/components/Filter/StatusDropdown.vue'

export default {
  components: {
    StatusDropdown,
    SearchTextInput
  },
  props: {
    statusFilter: {
      type: String,
      default: null
    },
    searchUserTeam: {
      type: String,
      default: ''
    },
    searchUserGroup: {
      type: String,
      default: ''
    },
    filter: {
      type: Object,
      default: () => (
        {
          searchTeam: '',
          searchGroup: ''
        }
      )
    }
  },
  computed: {
    searchUserGroupValue: {
      get () {
        return this.searchUserGroup
      },
      set (val) {
        this.$emit('update:search-user-group', val)
      }
    },
    searchUserTeamValue: {
      get () {
        return this.searchUserTeam
      },
      set (val) {
        this.$emit('update:search-user-team', val)
      }
    },
    statusFilterValue: {
      get () {
        return this.statusFilter
      },
      set (val) {
        this.$emit('update:status-filter', val)
      }
    }
  },
  methods: {
    fetchFilter () {
      this.$emit('fetch-filter')
    }
  }
}
</script>

<style>

</style>
